import { Outlet } from "react-router-dom";
import Footer from "../../components/common/layout/Footer";
import LanguageChangeModal from "../../components/common/layout/LanguageChangeModal";
import Search from "../../components/common/layout/Search";
import { useSelector } from "react-redux";
import { useEffect } from "react";
// import SubMegaMenu from "../../components/common/layout/SubMegaMenu";

const MainLayout = () => {
    const langOpen: boolean = useSelector((state: any) => state.data.langOpen);

    useEffect(() => {
        if (langOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [langOpen]);

    return (
        <>
            {langOpen && <LanguageChangeModal />}
            <Search />
            {/* <SubMegaMenu /> */}
            <Outlet />
            <Footer />
        </>
    );
};

export default MainLayout;